import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const Skeleton = () => {
  return (
    <div
      className={tw`w-full  bg-white p-4  rounded-md mb-8`}
      style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
    >
      <div className={tw`w-full  mt-2 flex justify-between items-center`}>
        <div className={tw`w-full flex gap-x-2 items-center`}>
          <div
            className={tw`w-16 h-16  rounded-full  bg-gray-200 animate-pulse`}
          ></div>
          <div className={tw`flex flex-col gap-y-2`}>
            <span
              className={tw`flex gap-x-1 w-full cursor-pointer w-24 h-3 rounded-md bg-gray-200 animate-pulse`}
            ></span>
            <span
              className={tw`flex gap-x-1 w-full cursor-pointer w-24 h-3 rounded-md bg-gray-200 animate-pulse`}
            ></span>
            <span
              className={tw`flex gap-x-1 w-full cursor-pointer w-24 h-3 rounded-md bg-gray-200 animate-pulse`}
            ></span>
          </div>
        </div>
        <span
          className={tw`flex gap-x-1 w-full cursor-pointer w-36 h-10 rounded-md bg-gray-200 animate-pulse`}
        ></span>
      </div>
      <div className={tw`grid grid-cols-2 w-full gap-x-6 gap-y-8 mt-12`}>
        <span className={tw` h-10 w-full bg-gray-200 animate-pulse`}></span>{" "}
        <span className={tw` h-10 w-full  bg-gray-200 animate-pulse`}></span>{" "}
        <span className={tw` h-10 w-full  bg-gray-200 animate-pulse`}></span>{" "}
        <span className={tw`  h-10 w-full bg-gray-200 animate-pulse`}></span>{" "}
        <span className={tw`  h-10 w-full  bg-gray-200 animate-pulse`}></span>{" "}
        <span className={tw`  h-10 w-full  bg-gray-200 animate-pulse`}></span>
      </div>
      <div className={tw`flex justify-end w-full my-4`}>
        <span
          className={tw`flex gap-x-1 w-full cursor-pointer w-36 h-10 rounded-md bg-gray-200 animate-pulse`}
        ></span>
      </div>
    </div>
  );
};

export default Skeleton;
